import { useCallback } from 'react';

type Callback = ((...args: any[]) => void) | undefined;

export default (...callbacks: Array<Callback>) =>
  useCallback(
    (...args) => {
      callbacks.forEach((cb) => {
        if (cb) {
          cb(...args);
        }
      });
    },
    [...callbacks],
  );
